import React from "react";
import { Container } from "react-bootstrap";
import styles from "./BackgroundImageWithRightTextLeftButton.module.scss";
import Link from "next/link";
import { useRouter } from "next/router";
import Button from "../../shared/Button/Button";
export default function BackgroundImageWithRightTextLeftButton({
  backgroundPath,
  primaryText,
  secondaryText,
  data,
  buttonColor = "black",
  buttonShape = "round",
}) {
  const { locale } = useRouter();
  const dir = locale === "ar" ? "rtl" : "ltr";
  const ctaText = locale === "ar" ? "تواصل معنا الآن" : "contact us now";

  return (
    <Container fluid style={{ padding: "0" }}>
      <div
        className={styles.background}
        dir={dir}
        style={{
          backgroundImage: `url(${backgroundPath})`,
          backgroundPosition: "top right",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className={styles.content}>
          <div className={styles["overlay-text"]}>
            <div className={styles["text-content"]}>
              <h3 className={styles["primary-text"]}>{primaryText}</h3>
              <p className={styles["secondary-text"]}>{secondaryText}</p>
            </div>
            <div className={styles["cta-wrapper"]}>
              <Link href="/contactus" legacyBehavior>
                <a className={styles["cta-link"]}>
                  <Button
                    buttonText={ctaText}
                    buttonColor={buttonColor}
                    buttonShape={buttonShape}
                  />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
